import moment from 'moment';
import {DateTimeFormat, ReportingPeriodEnum} from 'common/proxies/enum-proxy';

// DEPRECATED, DO NOT USE
// Used only in legacy analytics apps.
// Returns a custom period enum for a given duration of time.
export const getCustomPeriodEnum = (start, end) => {
  const startMoment = moment.utc(start);
  const endMoment = moment.utc(end);
  const interval = endMoment.diff(startMoment);
  switch (true) {
    case interval < moment.duration(48, 'hours'):
      return ReportingPeriodEnum.LESS_THAN_FOURTY_EIGHT_HOURS;
    case interval < moment.duration(7, 'days'):
      return ReportingPeriodEnum.LESS_THAN_SEVEN_DAYS;
    case interval < moment.duration(30, 'days'):
      return ReportingPeriodEnum.LESS_THAN_THIRTY_DAYS;
    case interval < moment.duration(90, 'days'):
      return ReportingPeriodEnum.LESS_THAN_NINETY_DAYS;
    case interval < moment.duration(12, 'months'):
      return ReportingPeriodEnum.LESS_THAN_TWELVE_MONTHS;
    default:
      return ReportingPeriodEnum.MORE_THAN_TWELVE_MONTHS;
  }
};

// DEPRECATED, DO NOT USE
// Used only in legacy analytics apps.
// Returns a custom period enum for a given duration of time,
// as expressed by a legacy analytics app date range from
// the URL fragment.
export const getCustomPeriodEnumFromDateParam = (param) => {
  const {start, end} = getParsedDateParams(param);
  return start && end ? getCustomPeriodEnum(start, end) : 0;
};

/* Returns a string of Moment formatting tokens for a given period. */
export const getDateFormat = (period) => {
  const slug = period && period.slug ? period.slug : '';
  switch (true) {
    case slug === ReportingPeriodEnum.NOW.slug:
    case slug === ReportingPeriodEnum.LAST_HOUR.slug:
    case slug === ReportingPeriodEnum.LAST_TWO_HOURS.slug:
    case slug === ReportingPeriodEnum.TODAY.slug:
    case slug === ReportingPeriodEnum.YESTERDAY.slug:
    case slug === ReportingPeriodEnum.LAST_TWENTY_FOUR_HOURS.slug:
    case slug === ReportingPeriodEnum.LAST_FOURTY_EIGHT_HOURS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_FOURTY_EIGHT_HOURS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_SEVEN_DAYS.slug:
      return DateTimeFormat.TIME;
    case slug === ReportingPeriodEnum.WEEK.slug:
    case slug === ReportingPeriodEnum.LAST_WEEK.slug:
    case slug === ReportingPeriodEnum.LAST_SEVEN_DAYS.slug:
    case slug === ReportingPeriodEnum.LAST_FOUR_WEEKS.slug:
      return DateTimeFormat.DAY_OF_WEEK;
    case slug === ReportingPeriodEnum.MONTH.slug:
    case slug === ReportingPeriodEnum.LAST_MONTH.slug:
    case slug === ReportingPeriodEnum.LAST_THIRTY_DAYS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_NINETY_DAYS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_THIRTY_DAYS.slug:
      return DateTimeFormat.DAY;
    case slug === ReportingPeriodEnum.YEAR.slug:
    case slug === ReportingPeriodEnum.LAST_YEAR.slug:
    case slug === ReportingPeriodEnum.LAST_SIX_MONTHS.slug:
    case slug === ReportingPeriodEnum.LAST_TWELVE_MONTHS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_TWELVE_MONTHS.slug:
    case slug === ReportingPeriodEnum.MORE_THAN_TWELVE_MONTHS.slug:
      return DateTimeFormat.MONTH;
    default:
      return DateTimeFormat.TEXTUAL_DAY_OF_WEEK;
  }
};

// DEPRECATED, DO NOT USE
// Used only in legacy analytics apps.
// Returns a date formatted in the style required by the old, deprecated
// URLs at rest.buildingos.com. Used only by legacy analytics apps.
export const getDateFormattedForRestURL = (date, excludeMinutes) => {
  return [
    moment(date).format('YYYY/MM/DD'),
    excludeMinutes ? null : moment(date).format('HH:mm:ss'),
  ]
    .filter((element) => element)
    .join('%20');
};

// Returns a string of Moment formatting tokens for a given period,
// and provides for more verbose formatting the tokens returned by
// getDateFormat().
export const getDateFormatVerbose = (period) => {
  const slug = period && period.slug ? period.slug : '';
  switch (true) {
    case slug === ReportingPeriodEnum.NOW.slug:
    case slug === ReportingPeriodEnum.LAST_HOUR.slug:
    case slug === ReportingPeriodEnum.LAST_TWO_HOURS.slug:
      return DateTimeFormat.TIME;
    case slug === ReportingPeriodEnum.TODAY.slug:
    case slug === ReportingPeriodEnum.YESTERDAY.slug:
    case slug === ReportingPeriodEnum.WEEK.slug:
    case slug === ReportingPeriodEnum.LAST_WEEK.slug:
    case slug === ReportingPeriodEnum.LAST_TWENTY_FOUR_HOURS.slug:
    case slug === ReportingPeriodEnum.LAST_FOURTY_EIGHT_HOURS.slug:
    case slug === ReportingPeriodEnum.LAST_SEVEN_DAYS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_FOURTY_EIGHT_HOURS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_SEVEN_DAYS.slug:
      return DateTimeFormat.TEXTUAL_DAY_OF_WEEK;
    case slug === ReportingPeriodEnum.LAST_FOUR_WEEKS.slug:
    case slug === ReportingPeriodEnum.MONTH.slug:
    case slug === ReportingPeriodEnum.LAST_MONTH.slug:
    case slug === ReportingPeriodEnum.LAST_THIRTY_DAYS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_NINETY_DAYS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_THIRTY_DAYS.slug:
      return DateTimeFormat.TEXTUAL;
    case slug === ReportingPeriodEnum.YEAR.slug:
    case slug === ReportingPeriodEnum.LAST_YEAR.slug:
    case slug === ReportingPeriodEnum.LAST_SIX_MONTHS.slug:
    case slug === ReportingPeriodEnum.LAST_TWELVE_MONTHS.slug:
    case slug === ReportingPeriodEnum.LESS_THAN_TWELVE_MONTHS.slug:
    case slug === ReportingPeriodEnum.MORE_THAN_TWELVE_MONTHS.slug:
      return DateTimeFormat.ISO_YEAR_MONTH;
    default:
      return DateTimeFormat.TEXTUAL_DAY_OF_WEEK;
  }
};

// DEPRECATED, DO NOT USE
// Used only in legacy analytics apps.
// Returns a date range formatted for legacy URL fragments.
export const getDateParam = (start, end, format = true) => {
  if (format) {
    const startParam = moment(start).format(DateTimeFormat.ISO_DATE.moment);
    const endParam = moment(end).format(DateTimeFormat.ISO_DATE.moment);
    return `${startParam}___${endParam}`;
  }
  return `${start}___${end}`;
};

// DEPRECATED, DO NOT USE
// Used only in legacy analytics apps.
// Returns a Date object representing the end of a given period.
export const getEndOfPeriod = (startDate, period = {}, toUTC = true) => {
  // Non-UTC is only used for Blocks, due to the way
  // that dates are formatted in those reports.
  const start = toUTC ? moment.utc(startDate) : moment(startDate);
  if (!start || isNaN(start.milliseconds()) || !period || !period.slug) {
    return null;
  }
  switch (period.slug) {
    case ReportingPeriodEnum.LAST_HOUR.slug:
    case ReportingPeriodEnum.NOW.slug:
      return start.endOf('hour').toDate();
    case ReportingPeriodEnum.TODAY.slug:
    case ReportingPeriodEnum.YESTERDAY.slug:
      return start.endOf('day').toDate();
    case ReportingPeriodEnum.LAST_WEEK.slug:
    case ReportingPeriodEnum.WEEK.slug:
      return start.endOf('week').toDate();
    case ReportingPeriodEnum.LAST_MONTH.slug:
    case ReportingPeriodEnum.MONTH.slug:
      return start.endOf('month').toDate();
    case ReportingPeriodEnum.LAST_YEAR.slug:
    case ReportingPeriodEnum.YEAR.slug:
      return start.endOf('year').toDate();
    case ReportingPeriodEnum.LAST_TWO_HOURS.slug:
      return start.add(1, 'hours').endOf('hour').toDate();
    case ReportingPeriodEnum.LAST_TWENTY_FOUR_HOURS.slug:
      return start.add(24, 'hours').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_FOURTY_EIGHT_HOURS.slug:
      return start.add(48, 'hours').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_SEVEN_DAYS.slug:
      return start.add(7, 'days').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_FOUR_WEEKS.slug:
      return start.add(4, 'weeks').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_THIRTY_DAYS.slug:
      return start.add(30, 'days').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_SIXTY_DAYS.slug:
      return start.add(60, 'days').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_NINETY_DAYS.slug:
      return start.add(90, 'days').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_SIX_MONTHS.slug:
      return start.add(6, 'months').endOf('day').toDate();
    case ReportingPeriodEnum.LAST_TWELVE_MONTHS.slug:
      return start.add(12, 'months').endOf('day').toDate();
    default:
      return null;
  }
};

// DEPRECATED, DO NOT USE
// Used only in legacy analytics apps.
// Accepts a date range param from the URL fragment in legacy
// analytics apps, and returns Date objects representing that range.
export const getParsedDateParams = (param) => {
  const [start, end] = param ? param.split('___') : [];
  if (start && end) {
    const endMoment = moment(end).endOf('day');
    return {
      start: moment(start).toDate(),
      end: endMoment.toDate(),
      interval: endMoment.diff(start),
    };
  }
  return {};
};

/* Get a moment duration of a period or a custom period */
export const getDuration = (start, end) => {
  if (!start || !end) {
    return null;
  }
  const startMoment = moment.utc(start);
  const endMoment = moment.utc(end);
  return moment.duration(endMoment - startMoment);
};

/* Accepts an array of Date objects and returns the first and last ones. */
export const getStartAndEnd = (dates) => {
  if (dates && dates.length) {
    const filtered = dates.filter((date) => date && date instanceof Date);
    return filtered.length
      ? [new Date(Math.min(...filtered)), new Date(Math.max(...filtered))]
      : [];
  }
  return [];
};

// Accepts an array of timeseries data and returns
// start and end Date objects for that series.
export const getStartAndEndOfSeries = (data) => {
  if (data && data.length) {
    const dates = data
      .map((datum) => (datum && datum.date ? new Date(datum.date) : null))
      .filter((datum) => datum);
    return dates.length
      ? [new Date(Math.min(...dates)), new Date(Math.max(...dates))]
      : [];
  }
  return [];
};

// Given 2 dates and date format,
// determine if tick values will be duplicates
// Ex) Given a format for a single day, say 'Fri' for Friday, date1 and date2
// would look like duplicates if they are both Friday.  This
// function would determine that they are not duplicates if they
// are different Fridays.
// Expects JS dates, not moment.js dates
export const isDuplicateTickValue = (date1, date2, formatForTick) => {
  // Get all momentJs period indicators, in increasing size
  // Millisecond, second, minute, hour, hour, day, day, week, month, quarter, year
  const periodIndicators = [
    'ms',
    's',
    'm',
    'h',
    'H',
    'L',
    'd',
    'D',
    'w',
    'M',
    'Q',
    'Y',
  ];

  function getTickPeriodIndicator(format) {
    const parsedFormat = format?.moment || format;

    // The first letter in a string format indicates which period the date
    // Format will convey. Determine the period being conveyed by the tick.
    const firstLetter = parsedFormat[0];

    // If the format wants milliseconds, it is a special case, because
    // The first letter 'm' conflicts with minute
    const isMillisecond = parsedFormat.slice(0, 2) === 'ms';

    return isMillisecond ? 'ms' : firstLetter;
  }

  const tickPeriodIndicator = getTickPeriodIndicator(formatForTick);

  const {
    seconds,
    minutes,
    hours,
    dayOfYear,
    // Use isoWeeks - week & weeks return NaN unexpectedly
    // In some cases (seems to be in Chrome only)
    isoWeeks,
    month,
    quarter,
    year,
  } = moment.prototype;

  // disabling eslint because these aren't really names, they're
  //   string literals contained by `periodIndicators` above

  const nextLargestPeriodGetters = {
    ms: seconds,
    s: minutes,
    m: hours,
    h: dayOfYear,
    H: dayOfYear,
    L: dayOfYear,
    d: isoWeeks,
    D: isoWeeks,
    w: month,
    M: quarter,
    Q: year,
    // Just get year b/c there is no larger period than year
    // Also, it's unlikely that the same year would show
    // Twice in the same timeseries
    Y: year,
  };

  const startingIndex = periodIndicators.indexOf(tickPeriodIndicator);
  const largerPeriodIndicators = periodIndicators.slice(startingIndex);

  // For each period larger than the tickPeriod
  for (let index = 0; index < largerPeriodIndicators.length; index++) {
    const indicator = largerPeriodIndicators[index];
    // Compare the next largest period for both dates
    const getNextLargestPeriodFor = nextLargestPeriodGetters[indicator];
    const date1Period = getNextLargestPeriodFor.call(moment(date1));
    const date2Period = getNextLargestPeriodFor.call(moment(date2));

    // If the date1 next largest period is different from
    // The date2 next largest period...
    if (date1Period !== date2Period) {
      // The tick value is not a duplicate
      return false;
    }
  }

  // If each of the larger periods is the same
  // The tick value is a duplicate
  return true;
};
